import { ElementRef, Injectable } from '@angular/core';
import * as smoothscroll from "smoothscroll-polyfill";
import { DeviceService } from './device.service';

@Injectable({ providedIn: 'root' })
export class ScrollToElementService {

    public defaultOptions: ScrollIntoViewOptions = {
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
    }

    constructor(private device: DeviceService) {
        if(!this.device.isPlatformServer()) smoothscroll.polyfill();
    }

    /**
     * NOT RECOMMENDED, use scrollToElementRef() or scrollToElement() if possible: Scrolls to a specific id
    */
    public scrollToId(id: string, options: ScrollIntoViewOptions = this.defaultOptions) {
        let element = document.getElementById(id);
        return this.scrollToElement(element, options);
    }

    /**
     * Scrolls to a specific elementRef
    */
    public scrollToElementRef(elementRef: ElementRef<HTMLElement>, options: ScrollIntoViewOptions = this.defaultOptions) {
        if(!elementRef) return console.log("cannot find elementRef");
        return this.scrollToElement(elementRef.nativeElement, options);
    }

    /**
     * Scrolls to a specific element
    */
    public scrollToElement(element: HTMLElement, options: ScrollIntoViewOptions = this.defaultOptions) {
        if(!element) return console.log("cannot find element");
        return element.scrollIntoView(options);
    }

    /**
     * Scrolls to a specific element in a specific list (avoid scrolling the rest if the page or window)
     * Remember to set the parent position: relative otherwise the offset will be 'wrong'
     * scroll-behavior: smooth is also cool
    */
    public scrollToElementInList(elementId: string, scrollContainer: HTMLElement, direction: 'Vertical' | 'Horizontal') {
        let element = document.getElementById(elementId);
        if(!element) return console.log("Cannot find element to scroll to");
        if(!scrollContainer) return console.log("Scroll container does not exist, skip scroll to element.");

        (direction == 'Vertical') ? scrollContainer.scrollTop = element.offsetTop : scrollContainer.scrollLeft = element.offsetLeft;
    }
}
